import React, { useEffect, useState } from "react";
import { GraphvizViewer } from "../Graphviz/GraphvizViewer";
import { Model } from "../../powerFlow/highs";
import { modelToGraphviz } from "../../utils/modelUtils";

interface Props {
  model?: Model;
  selectedComponent: number;
}



const OptimizationGraph: React.FC<Props> = ({ model, selectedComponent }) => {
  const [dotSource, setDotSource] = useState<string>("");



  useEffect(() => {
    if (model) {
      const dot = modelToGraphviz(model);
      setDotSource(dot);
    }
  }, [model]);

  if (!model) {
    return (
      <div style={{ padding: "16px", color: "#666", fontStyle: "italic" }}>
        No optimization model available for component {selectedComponent}
      </div>
    );
  }

  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <div style={{ marginBottom: "12px" }}>
        <h4 style={{ margin: "0 0 8px 0", fontSize: "14px" }}>
          Optimization Problem Graph - Component {selectedComponent}
        </h4>
        <div style={{ fontSize: "12px", color: "#666" }}>
          Variables: {model?.variables.length || 0}, 
          Constraints: {model?.constraints.length || 0}
        </div>
      </div>
      
      <div style={{ flex: 1 }}>
        <GraphvizViewer
          dotSource={dotSource}
          style={{ width: '100%', height: '100%' }}
        />
      </div>
      
      {/* Legend */}
      <div style={{ 
        marginTop: "8px", 
        padding: "8px", 
        background: "#f8f8f8", 
        borderRadius: "4px",
        fontSize: "12px"
      }}>
        <div style={{ fontWeight: "bold", marginBottom: "4px" }}>Legend:</div>
        <div style={{ display: "flex", gap: "16px" }}>
          <div>
            <span style={{ 
              display: "inline-block", 
              width: "12px", 
              height: "12px", 
              backgroundColor: "lightblue", 
              border: "1px solid blue",
              borderRadius: "50%",
              marginRight: "4px" 
            }}></span>
            Decision Variables
          </div>
          <div>
            <span style={{ 
              display: "inline-block", 
              width: "12px", 
              height: "12px", 
              backgroundColor: "lightcoral", 
              border: "1px solid red",
              marginRight: "4px" 
            }}></span>
            Constraints & Objective
          </div>
        </div>
      </div>
    </div>
  );
};

export default OptimizationGraph;